import type { Block, SourceLanguageCode } from '@ellie/shared';
import { VocabularyGridPreview } from './VocabularyGridPreview';
import { GuidedConversationPreview } from './GuidedConversationPreview';
import { FillInTheBlankPreview } from './FillInTheBlankPreview';
import { ReadingComprehensionPreview } from './ReadingComprehensionPreview';
import { MatchingExercisePreview } from './MatchingExercisePreview';
import { ScenarioPromptsPreview } from './ScenarioPromptsPreview';
import { TranslationChallengePreview } from './TranslationChallengePreview';
import { ConjugationSpotlightPreview } from './ConjugationSpotlightPreview';
import { GrammarExplanationPreview } from './GrammarExplanationPreview';

interface BlockRendererProps {
  block: Block;
  index: number;
  nativeLanguage: SourceLanguageCode;
  targetLanguage: string;
  pageNumber: number;
}

/**
 * Dispatches to the correct block preview component based on `block.type`.
 */
export function BlockRenderer({
  block,
  index,
  nativeLanguage,
  targetLanguage,
  pageNumber,
}: BlockRendererProps) {
  switch (block.type) {
    case 'vocabulary_grid':
      return (
        <VocabularyGridPreview
          block={block}
          index={index}
          nativeLanguage={nativeLanguage}
          targetLanguage={targetLanguage}
          pageNumber={pageNumber}
        />
      );
    case 'guided_conversation':
      return (
        <GuidedConversationPreview
          block={block}
          index={index}
          nativeLanguage={nativeLanguage}
          pageNumber={pageNumber}
        />
      );
    case 'fill_in_the_blank':
      return (
        <FillInTheBlankPreview
          block={block}
          index={index}
          nativeLanguage={nativeLanguage}
          targetLanguage={targetLanguage}
          pageNumber={pageNumber}
        />
      );
    case 'reading_comprehension':
      return (
        <ReadingComprehensionPreview
          block={block}
          index={index}
          nativeLanguage={nativeLanguage}
          pageNumber={pageNumber}
        />
      );
    case 'matching_exercise':
      return (
        <MatchingExercisePreview
          block={block}
          index={index}
          nativeLanguage={nativeLanguage}
          targetLanguage={targetLanguage}
          pageNumber={pageNumber}
        />
      );
    case 'scenario_prompts':
      return (
        <ScenarioPromptsPreview
          block={block}
          index={index}
          nativeLanguage={nativeLanguage}
          targetLanguage={targetLanguage}
          pageNumber={pageNumber}
        />
      );
    case 'translation_challenge':
      return (
        <TranslationChallengePreview
          block={block}
          index={index}
          nativeLanguage={nativeLanguage}
          targetLanguage={targetLanguage}
          pageNumber={pageNumber}
        />
      );
    case 'conjugation_spotlight':
      return <ConjugationSpotlightPreview block={block} index={index} pageNumber={pageNumber} />;
    case 'grammar_explanation':
      return <GrammarExplanationPreview block={block} index={index} pageNumber={pageNumber} />;
    default:
      return null;
  }
}
